import {config} from './config';

export const getConfig = () => {
  const {REACT_APP_APP_ENV = 'local'} = process.env;
  return config[REACT_APP_APP_ENV as keyof typeof config];
};
